import { createClient } from '@supabase/supabase-js';

// Fall back to harmless placeholders when the env is unset so the module never
// throws at import time. createClient('') throws "supabaseUrl is required",
// which would blank the whole app — even in dev-bypass mode where no login is
// ever needed. With placeholders the client constructs fine; getSession() reads
// localStorage (no network) and returns no session, so AUTH_DISABLED dogfooding
// works with zero Supabase config. Real login obviously needs the real values.
const url = import.meta.env.VITE_SUPABASE_URL || 'http://localhost:54321';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-anon-key';

if (!import.meta.env.VITE_SUPABASE_URL) {
  console.warn(
    '[FOUNDR-X] VITE_SUPABASE_URL not set — auth/login disabled. Fine for local ' +
      'dogfooding (AUTH_DISABLED), required before testing magic-link/Google sign-in.',
  );
}

export const supabase = createClient(url, anonKey);
